module.exports = __webpack_public_path__ + "static/media/cabriolet.22a2f222.svg";